import { Router } from '@angular/router';
import { Component, NgZone, OnInit } from '@angular/core';
import { HeaderService } from 'src/app/service/header.service';

@Component({
    selector: 'app-nav-bar',
    templateUrl: './nav-bar.component.html',
    styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent implements OnInit {
    publictoken: any

    constructor(private _router: Router, private headerservice: HeaderService, private ngzone: NgZone) { }

    header_islogin: boolean = false;
    token:any
    email: any;
    username: any;
    ngOnInit(): void {
        //   this.token = localStorage.getItem('core_spa_user_token');

        //   console.log('token',this.token);

        this.headerservice.islogin.subscribe(res => {
            console.log('res', res);
            //  this.header_islogin = res;
            this.ngzone.run(() => {
                //   this.header_islogin = res;
                this.token = localStorage.getItem('core_spa_user_token');
                console.log('token', this.token);
                if (!this.token) {
                    console.log('not token', this.token);
                    this.header_islogin = false;


                } else {
                    this.header_islogin = true;
                    console.log('yes token', this.token);
                    this.email = localStorage.getItem('user_email');
                    this.username = localStorage.getItem('user_userName');
                    //   this.header_islogin = false;
                }

                console.log('login true>>>>>>>>>>>>>', this.header_islogin);
            });

            // if (res ==  true) {



            // }else{

            //     this.ngzone.run(()=>{
            //         // this.token = localStorage.getItem('core_spa_user_token');
            //         // console.log('token',this.token);
            //        this.header_islogin = res;
            //         console.log('login false>>>>>>>>>>>>>' , this.header_islogin);

            //     });
            // }

        });

    }

    public On_LogOut():void {
        console.log('logout');
        
        localStorage.removeItem('core_spa_user_token');
        localStorage.removeItem('user_email');
        localStorage.removeItem('user_userName');
        this._router.navigate(['/home']);
        //  this.header_islogin= false;
        this.token = localStorage.getItem('core_spa_user_token');

        console.log('logout>>>>>>> calllllll', this.token);
        this.headerservice.islogin.next(false);
        window.location.reload();
    }

    profile() {
        this._router.navigate(['/profile'])
    }


    On_Login() {
        this._router.navigate(['/login'])
    }

    change_password() {
        this._router.navigate(['/change-password'])
    }
}
